import * as VolumeActions from "actions/VolumeActions";
import VolumeControlComponent from "components/VolumeControlComponent";
import { connect } from "react-redux";

const connector = connect(
  (state) => ({
    muted: state.volume.muted,
  }),
  (dispatch) => ({
    onToggleMute: () => dispatch(VolumeActions.toggleVolumeMuted()),
  }),
);

export default connector(VolumeControlComponent);
